<template lang="pug">
    .columns.is-vcentered.is-mobile
      .container.has-text-centered.column.p0
        h1 {{$t('componentes.coletor.views.ListaColetores.titulo')}}

        .columns.is-centered
          .column.is-half
            InputText(v-focus="", placeholder='buscar coletor', v-model.trim="filtroColetor"
              autocomplete="on", required="true")
        .columns.is-centered(v-if="coletores")
          .column.is-half
            RadioSelect(
              nomeGrupo="coletores"
              :opcoes="coletores"
              opcaoRef="nome"
              @opcaoSelecionada="selecionarColetor"
            )
        .columns.is-centered
          .column.is-one-quarter
            Button3d(@click="acessarRotaDeConfirmacao" color="success" size="medium" :block="true") {{ $t('componentes.coletor.views.listaColetores.confirmar') }}
          .column.is-one-quarter
            Button3d(@click="acessarRotaDeTriagem" color="info" size="medium" :block="true") {{ $t('componentes.coletor.views.listaColetores.voltar') }}

</template>

<script>
import RadioSelect from '@/common/Seletores/RadioSelect.vue'
export default {
  name: 'ListaColetores',
  components: { RadioSelect },
  computed: {
    coletores: {
      get () { return this.$store.getters['coletor/coletoresFiltrados'] }
    },
    filtroColetor: {
      get () { return this.$store.state.coletor.coletores.filtro },
      set (value) { this.$store.commit('coletor/atribuiFiltroColetor', value) }
    },
    coletorSelecionado () {
      return this.$store.state.coletor.coletores.selecionado
    }
  },
  methods: {
    acessarRotaDeConfirmacao () {
      if (!this.coletorSelecionado) {
        this.$swal({type: 'info', text: this.$t('componentes.coletor.views.listaColetores.infoAcessarRota')})
        return
      }
      this.$store.dispatch('coletor/buscarColetorPorId')
      this.$router.push({ name: 'confirmacaoInfoColetor' })
    },
    acessarRotaDeTriagem () {
      this.$router.push({ name: 'triagemColetor' })
    },
    selecionarColetor (event) {
      this.$store.commit('coletor/atribuiColetorSelecionado', event)
    },
    buscarMaisColetores () {
      this.$store.dispatch('coletor/buscarColetores')
    }
  }
}
</script>

<style scoped>
.coletor.selecionado {
  background-color:rgb(228, 228, 228);
  transform: translateX(10px);
}
.radio-label {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #000;
}
.radio-label .coletor-info {
  flex: 1;
  text-align: left;
  cursor: pointer;
}
.radio-label .icone-chapado-certo {
  margin: auto;
  color: var(--color-success);
}
</style>
